import React from 'react'

import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import { eventContactProps } from '../../../propTypes'

import './EventContact.css'

const EventContact = ({ t, contact, title }) => (
    <div className="event-contact">
        <h4>{title}</h4>
        <div className="event-contact__fullName">{contact.fullName}</div>
        <div className="event-contact__tel">
            {contact.hasPhoneNumbers && (
                <>
                    <span>{t('eventDetails.contacts.tel')}</span>
                    <div className="event-contact__tel__data">
                        {contact.phoneNumbers.map((phone, i) => (
                            <div key={i}>{phone}</div>
                        ))}
                    </div>
                </>
            )}
        </div>
        <div className="event-contact__email">
            <span>e-mail</span>
            <span className="event-contact__email__data">{contact.email}</span>
        </div>
    </div>
)

EventContact.propTypes = {
    contact: PropTypes.shape(eventContactProps),
    title: PropTypes.string
}

export { EventContact }
export default withTranslation()(EventContact)
